// extracted by mini-css-extract-plugin
export var container = "_3v-0";
export var icon = "_3v-1";
export var text = "_3v-2";